var _style, _g, _g2, _g3, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRename(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#626161;}\r\n\t.st1{display:none;}\r\n\t.st2{display:inline;}\r\n\t.st3{opacity:0.2;}\r\n\t.st4{fill:#F0A328;}\r\n\t.st5{fill:none;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Guides"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.6782,4.5328l-3.2154-3.2114C11.2552,1.114,10.9794,1,10.686,1c-0.0005,0-0.001,0-0.0015,0 c-0.2939,0.0005-0.5696,0.1154-0.7768,0.3234l-8.55,8.5863c-0.2027,0.204-0.3159,0.474-0.3189,0.7602l-0.0387,3.2202 c-0.0039,0.2998,0.1116,0.5817,0.3252,0.7929C1.5329,14.888,1.8058,15,2.0962,15c0.0088,0,0.0177,0,0.0265,0l3.2703-0.0724 c0.2841-0.0063,0.5515-0.1203,0.7523-0.3214l8.5329-8.5223C14.8859,5.8765,15,5.6011,15,5.3081 C15,5.0156,14.8859,4.7402,14.6782,4.5328z M5.3705,13.9257l-3.2703,0.0724l-0.097-0.0959l0.0387-3.2206l6.6493-6.7074 l3.336,3.3322L5.3705,13.9257z M13.9689,5.3756l-1.2311,1.2241l-3.341-3.3374l1.222-1.2327h0.1347l3.2154,3.2114 C14.0008,5.2729,14.0008,5.3438,13.9689,5.3756z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Strokes",
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61137_00000145744958956399140280000009598277703433435295_",
    transform: "translate(422.59 0.59)",
    className: "st3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61125_00000005241697404254616930000001958894409172120249_",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_16308_00000156579749892878550130000006888317876906423716_",
    className: "st4",
    d: "M-467.1269,4.013h87 c2.2091,0,4,1.7909,4,4v55c0,2.2091-1.7909,4-4,4h-87c-2.2091,0-4-1.7909-4-4v-55 C-471.1269,5.8039-469.336,4.013-467.1269,4.013z"
  })))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st5",
    width: 16,
    height: 16
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRename);
export default __webpack_public_path__ + "static/media/Rename.21ffafada11fc238bb321c81e9ab16af.svg";
export { ForwardRef as ReactComponent };